/* eslint-disable prettier/prettier */
import React from 'react';
import { useTicketConfig } from "../../hooks/ticket";

function Overview({ team, show }) {
    const [ticketConfig] = useTicketConfig(team?.abbrv)
    const { info } = team;

    const ticketUrl = ticketConfig?.ticketUrl;

    const infoToUse = info.filter(i => !i.name.includes('Hemmaarena') && i.name !== '');

    if (!show) return null;

    return (
        <div className="data-container mt-4">
            {infoToUse.map((item) => (
                <div className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2">
                    <div className="col-4">
                        <strong>
                            {item.name}
                        </strong>
                    </div>
                    <div className="col-8">
                        {item.name === 'Officiell hemsida:' ?
                            <span className="children-links children-links--primary fw-bold" dangerouslySetInnerHTML={{__html: item.value}} /> :
                            item.value}
                    </div>
                </div>
            ))}
            <div className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2">
                <div className="col-4">
                    <strong>
                        Biljetter
                    </strong>
                </div>
                <div className="col-8 children-links children-links--primary fw-bold">
                    <a href={ticketUrl}>{ticketUrl}</a>
                </div>
            </div>
            <div className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2">
                <div className="col-4">
                    <strong>
                        Arena
                    </strong>
                </div>
                <div className="col-8 pb-4">
                    <img className="border-radius-10 mb-3" width="100%" src="/wp-content/themes/sef-leagues/images/friends-arena.png" alt="" />
                    <div className="data-container">
                        <div className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2">
                            <div className="col-4">
                                <strong>
                                    Namn
                                </strong>
                            </div>
                            <div className="col-8">
                                Friends Arena
                            </div>
                        </div>
                        <div className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2">
                            <div className="col-4">
                                <strong>
                                    Kapacitet
                                </strong>
                            </div>
                            <div className="col-8">
                                50 000
                            </div>
                        </div>
                        <div className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2">
                            <div className="col-4">
                                <strong>
                                    Öppnad
                                </strong>
                            </div>
                            <div className="col-8">
                                2013
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Overview;
